import React, { useState } from "react";
import "../styles/SegmentoModal.css";

/**
 * SegmentoModal
 * Muestra la lista de segmentos disponibles (cargada desde segmento.json)
 * y permite seleccionar uno antes de imprimir el ticket.
 *
 * Props:
 *   segmentos   - array de { id, nombre } cargados desde segmento.json
 *   onCancel    - función llamada al presionar Cancelar (no imprime, no guarda)
 *   onConfirm   - función(segmentoNombre) llamada al presionar Continuar
 *   loading     - bool: true mientras el endpoint guarda el segmento
 *   error       - string | null: mensaje de error del endpoint
 */
const SegmentoModal = ({ segmentos, onCancel, onConfirm, loading, error }) => {
  const [selected, setSelected] = useState(null);

  const handleConfirm = () => {
    if (!selected) return;
    onConfirm(selected.nombre);
  };

  const handleContentClick = (e) => e.stopPropagation();

  return (
    <div className="segmento-overlay" onClick={onCancel}>
      <div className="segmento-modal" onClick={handleContentClick}>

        {/* Header */}
        <div className="segmento-header">
          <h3>Seleccione el segmento</h3>
        </div>

        {/* Lista de segmentos */}
        <div className="segmento-body">
          {segmentos && segmentos.length > 0 ? (
            <ul className="segmento-list">
              {segmentos.map((seg) => (
                <li key={seg.id}>
                  <label className={`segmento-option${selected?.id === seg.id ? ' segmento-option--selected' : ''}`}>
                    <input
                      type="radio"
                      name="segmento"
                      value={seg.id}
                      checked={selected?.id === seg.id}
                      onChange={() => setSelected(seg)}
                      disabled={loading}
                    />
                    <span className="segmento-radio-dot" />
                    <span className="segmento-nombre">{seg.nombre}</span>
                  </label>
                </li>
              ))}
            </ul>
          ) : (
            <p className="segmento-empty">No hay segmentos disponibles.</p>
          )}

          {/* Mensaje de error del endpoint */}
          {error && (
            <div className="segmento-error">{error}</div>
          )}
        </div>

        {/* Acciones */}
        <div className="segmento-actions">
          <button
            className="segmento-btn segmento-btn--cancel"
            onClick={onCancel}
            disabled={loading}
          >
            Cancelar
          </button>
          <button
            className="segmento-btn segmento-btn--confirm"
            onClick={handleConfirm}
            disabled={!selected || loading}
          >
            {loading ? 'Guardando…' : 'Continuar'}
          </button>
        </div>

      </div>
    </div>
  );
};

export default SegmentoModal;
